module.exports = __webpack_public_path__ + "img/college-shop-header-bg.90661db.png";